import * as React from 'react';

export default function InputSelect(props) {
  const registration = props.register && props.name ? props.register(props.name) : {};

  const onChangeObject = {};

  if (props.onChange) {
    onChangeObject.onChange = (e) => {
      props.onChange(e.target.value);
    };
  }

  if (props.nostyle) {
    return (
      <>
        <select id={props.name} className={`form-control ${props.error ? 'is-invalid' : ''} ${props.valid ? 'is-valid fw-bold' : ''}`} {...registration} defaultValue={props.value} {...onChangeObject}>
          <option value="" disabled>{props.placeholder}</option>
          {props.options && props.options.map((opt, index) => <option key={index} value={opt.id ? opt.id : opt}>{opt.name ? opt.name : opt}</option>)}
        </select>
        <div className="invalid-feedback">
          {props.error}
        </div>
      </>
    );
  }

  return (
    <div className="form-input-container">
      <div className="row">
        <div className={`col-xl-4 offset-xl-4 col-md-6 offset-md-3 ${props.colClass ? props.colClass : ''}`}>
          <label className="f-label">{props.label}</label>
          <div className="d-flex">
            <div className="w-100">
              <select id={props.name} className={`form-control ${props.error ? 'is-invalid' : ''} ${props.valid ? 'is-valid fw-bold' : ''}`} value={props.value} disabled={props.disabled ?? false} {...registration} {...onChangeObject}>
                <option value="" disabled className="fw-normal">{props.placeholder}</option>
                {props.options && props.options.map((opt, index) => <option key={index} value={opt.id ? opt.id : opt}>{opt.name ? opt.name : opt}</option>)}
              </select>
              <div className="general-input-error">
                {props.error}
              </div>
            </div>
            {props.children && <div className="children">{props.children}</div>}
            {props.onRemove
                            && (
                            <span
                              style={{
                                display: 'block', marginLeft: '9px', marginTop: '5px', width: '40px', cursor: 'pointer',
                              }}
                              title="Remove"
                              onClick={props.onRemove}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M175 175C184.4 165.7 199.6 165.7 208.1 175L255.1 222.1L303 175C312.4 165.7 327.6 165.7 336.1 175C346.3 184.4 346.3 199.6 336.1 208.1L289.9 255.1L336.1 303C346.3 312.4 346.3 327.6 336.1 336.1C327.6 346.3 312.4 346.3 303 336.1L255.1 289.9L208.1 336.1C199.6 346.3 184.4 346.3 175 336.1C165.7 327.6 165.7 312.4 175 303L222.1 255.1L175 208.1C165.7 199.6 165.7 184.4 175 175V175zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z" /></svg>
                            </span>
                            )}
          </div>
        </div>
        {props.BottomComponent && props.BottomComponent}
      </div>
    </div>
  );
}
